'use client';

import dynamic from 'next/dynamic';
import { Suspense } from 'react';

import { useIsEmailConfirmed, useIsSkippedEmailConfirm } from '~features/tags';
const Content = dynamic(
	() => import('./dynamicContent').then((mod) => mod.Content),
	{
		ssr: false,
	}
);

export const EmailConfirmHeaderBanner = () => {
	const skipEmailConfirm = useIsSkippedEmailConfirm();
	const [emailConfirmed] = useIsEmailConfirmed();

	if (!skipEmailConfirm || emailConfirmed) {
		return null;
	}

	return (
		<Suspense fallback={null}>
			<Content />
		</Suspense>
	);
};
